/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ERepairshopTypeRequest = 'Repairshop' | 'Bikeshop' | 'Both' | 'OnlineShop' | 'All';

export const ERepairshopTypeRequest = {
    Repairshop: 'Repairshop' as ERepairshopTypeRequest,
    Bikeshop: 'Bikeshop' as ERepairshopTypeRequest,
    Both: 'Both' as ERepairshopTypeRequest,
    OnlineShop: 'OnlineShop' as ERepairshopTypeRequest,
    All: 'All' as ERepairshopTypeRequest
};

